/** The bar's page list: a disclosure of links to the prototype's pages, with the open one marked `aria-current`. */
export class PrototypePageSwitch {
    private readonly button: HTMLButtonElement | null;
    private readonly menu: HTMLElement | null;

    constructor(element: HTMLElement) {
        this.button = element.querySelector('[data-prototype-page-switch]');
        this.menu = element.querySelector('.prototype-page-menu');

        this.button?.addEventListener('click', () => this.setOpen(this.menu?.hidden ?? false));
        // The open page is already here; following its link would reload without the state in the URL.
        this.menu?.querySelectorAll('a[aria-current="page"]').forEach(link => link.addEventListener('click', (e: Event) => {
            e.preventDefault();
            this.close(true);
        }));
        element.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape' && this.menu && !this.menu.hidden) {
                e.stopPropagation();
                this.close(true);
            }
        });
        document.addEventListener('click', (e: MouseEvent) => {
            if (!(e.target instanceof Node && element.contains(e.target))) {
                this.close(false);
            }
        });
    }

    public close(returnFocus: boolean) {
        if (this.menu && !this.menu.hidden) {
            this.setOpen(false);
            if (returnFocus) {
                this.button?.focus();
            }
        }
    }

    private setOpen(open: boolean) {
        if (!this.menu) {
            return;
        }

        this.menu.hidden = !open;
        this.button?.setAttribute('aria-expanded', open.toString());
        if (open) {
            this.menu.querySelector<HTMLElement>('a')?.focus();
        }
    }
}
